import React, { useEffect, useState } from 'react';
import { Alert, Container, Spinner } from 'react-bootstrap';
import { notificar } from '../../components/SistemaToast/notificar';
import { urlApiProd } from '../utiles';
import CargarPreciosFletes from './CargarPreciosFletes';
import CargarTasas from './CargarTasas';
import PageHeader from '../../components/PageHeader/PageHeader';

const PreciosFletesYTasas = () => {
    const [puertos, setPuertos] = useState([]);
    const [ffw, setFFW] = useState([]);
    const [carriers, setCarriers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchApoyo = async () => {
            const token = localStorage.getItem('token');
            try {
                const responses = await Promise.all([
                    fetch(`${urlApiProd}/puertos`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${urlApiProd}/ffw`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${urlApiProd}/carriers`, { headers: { Authorization: `Bearer ${token}` } }),
                ]);
                if (responses.some(response => !response.ok)) {
                    throw new Error('No se pudieron cargar los datos de puertos, FFW o carriers');
                }

                const [puertosData, ffwData, carriersData] = await Promise.all(responses.map(response => response.json()));
                setPuertos(puertosData);
                setFFW(ffwData);
                setCarriers(carriersData);
            } catch (fetchError) {
                setError(fetchError.message);
                notificar.error(fetchError.message, { toastId: 'precios-fletes-tasas-apoyo' });
            } finally {
                setLoading(false);
            }
        };

        fetchApoyo();
    }, []);

    return (
        <Container fluid className="py-3 ui-page">
            <PageHeader
                eyebrow="Logística"
                title="Precios de Fletes y Tasas"
                descripcion="Consulta las tarifas vigentes o carga nuevos precios desde un archivo."
            />
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" role="status" />
                    <span className="ms-2">Cargando datos de apoyo...</span>
                </div>
            ) : error ? (
                <Alert variant="danger">{error}</Alert>
            ) : (
                <>
                    <CargarPreciosFletes embedded puertos={puertos} ffw={ffw} carriers={carriers} />
                    <CargarTasas embedded puertos={puertos} ffw={ffw} carriers={carriers} />
                </>
            )}
        </Container>
    );
};

export default PreciosFletesYTasas;
